import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';

// export interface IFetchVideoLinksStatusState {
//   value: enumWorkflowState | null
// }

const initialState: enumWorkflowState | null = null;

export const fetchVideoLinksStatusSlice = createSlice({
  name: 'fetchVideoLinksStatus',
  initialState,
  reducers: {
    setFetchVideoLinksStatus: (state: enumWorkflowState | null, action: PayloadAction<enumWorkflowState>) => {
      state = action.payload;
    },
    clearFetchVideoLinksStatus: (state: enumWorkflowState | null) => {
      state = null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { setFetchVideoLinksStatus, clearFetchVideoLinksStatus } = fetchVideoLinksStatusSlice.actions;

// export the core reducer for the slice
export const fetchVideoLinksStatusReducer = fetchVideoLinksStatusSlice.reducer;

export default fetchVideoLinksStatusSlice.reducer;